import MuseFlowAudio, { isNativeAudioRoute } from 'Utils/MuseFlowAudioPlugin';

/**
 * When the iOS and Android apps switch their native piano on.
 *
 * On the apps a keyboard's notes sound through the native piano (the web piano
 * is off there), so the piano has to be on wherever the keyboard can be played.
 * Switching it on loads the piano samples (about 46 MB on Android, decoded over
 * several seconds), so a user with no keyboard connected must not load them at
 * startup on the roadmap: the piano is on when a keyboard is connected, or on a
 * screen that plays audio itself (lessons, tutorials, repertoire, exercises).
 * Either way only once the user's settings are in and audio is not turned off.
 *
 * Switching the piano off stops any note still sounding; the loaded samples are
 * kept, so a keyboard that comes back plays at once.
 *
 * The piano also plays while a tutorial video does, on both apps (MUS-280 once
 * held it off on iOS, where a note re-activated the audio session and stopped
 * the web view's video; the iOS engine no longer does that).
 */
export interface NativePianoConditions {
  userDataFetched: boolean;
  /** The user's sound setting; only `false` turns the piano off. */
  audioOn: boolean | undefined;
  pathname: string;
  keyboardConnected: boolean;
}

export const wantsNativePiano = ({
  userDataFetched,
  audioOn,
  pathname,
  keyboardConnected,
}: NativePianoConditions): boolean =>
  userDataFetched && audioOn !== false && (keyboardConnected || isNativeAudioRoute(pathname));

/** The app wants the native piano on or off (see `wantsNativePiano`). */
export const setNativePianoWanted = (wanted: boolean): void => {
  void MuseFlowAudio.setPianoEnabled({ enabled: wanted });
};
